import { render } from "./OpenModule.vue?vue&type=template&id=7cb69a3e&scoped=true"
import script from "./OpenModule.vue?vue&type=script&lang=js"
export * from "./OpenModule.vue?vue&type=script&lang=js"

import "./OpenModule.vue?vue&type=style&index=0&id=7cb69a3e&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cb69a3e"]])

export default __exports__